<template>
  <div class="bh-group">
    <slot />
  </div>
</template>

<script lang="ts">
  export default defineNuxtComponent({
    name: 'BHGroup',
  });
</script>
